import { z } from 'zod'

export const schema = z.object({
  averageReviewScore: z.number(),
  bestScore: z.number().int(),
  countScore: z.number().int(),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  province_slug: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
